import { Component, OnInit, OnDestroy } from '@angular/core';
import { TicketService } from 'src/app/services/ticket.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { saveAs } from 'file-saver';
import {  ActivatedRoute, Router } from '@angular/router';
import { CategoryItem, SubCategoryItem, AssignedToTeamItem ,TicketLogsItem ,ResolutionTypeList,TicketStatusEnum } from 'src/app/interface/ticket';
import { firstValueFrom, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { NzMessageService } from 'ng-zorro-antd/message';
import { InquiryService } from 'src/app/services/inquiry.service';
@Component({
  selector: 'app-mobile-ticket',
  templateUrl: './mobile-ticket.component.html',
  styleUrls: ['./mobile-ticket.component.css']
})
export class MobileTicketComponent implements OnInit, OnDestroy {
  // ✅ Fix: Subject for managing subscription cleanup (memory leak prevention)
  private destroy$ = new Subject<void>();

  // ⚠️ DEVELOPMENT OVERRIDE: Allow these users to access support features for testing
  // Remove this in production!
  private readonly DEV_SUPPORT_USERS = [
    'karl.li@gti.com.hk',
    'karl.li',
    'mike.ng@gti.com.hk',
    'mike.ng'
  ];
  ticketForm!: FormGroup; //提交表单
  remarkForm!:FormGroup;
  originalticketForm!: any; //提交表单
  ticketNo: string = ""    //ticketNo 用于submit之后显示弹窗上
  ticketId: number = 0;
  ticketGuid: string = ""; //组件传入Guid 用于获取当前ticket信息
  isSubmitVisible: boolean = false; // submit提交之后显示弹窗
  isCancelVisible: boolean = false; //取消弹窗显示
  isClosed: boolean = false; //关闭弹窗显示
  isReassignTeam: boolean = false; //分配弹窗显示
  userInfo = JSON.parse(localStorage.getItem("User") || '{}'); //获取当前登录用户信息，用于填充信息
  isSupport = false; //是否IT support - initialized to false, will be set properly in initAdminSupport
  isAdmin: boolean = false; // Track admin status for UI/logic purposes
  fileList: any[] = []; //文件上传数组
  fileListTag: any[] = [];//顯示文件列表与操作
  originalFileList: any[] = []; //原文件上传数组
  delFileList:any[] = [];//删除的文件
  assignedToTeamID = 0; //分配的team
  isShowLog: boolean = false; //是否显示日志
  isLoading: boolean = false; //是否保存
  isButtonLoading:boolean = false //是否点击按钮
  isShowLoading: boolean = false; //打开ticket时是否显示加载
  isShowAcceptSubCategory:boolean = false;
  isShowChangeSubCategoryReassignLog:boolean = false;
  isShowReassignTicket:boolean = false;
  fileName: string = ""; //文件名称集合
  isFileChange: boolean = false //文件是否改变
  showEmailList: string = ""; //抄送email列表名字
  isShowPdf: boolean = false; //是否显示pdf
  pdfSrc: string = ""; //pdf显示路径
  deviceInfo:string = "";
  pdfId:number = 0;//pdf ID 用於下載
  pdfName:string = "";//pdf Name 用於下載
  originalSubCategoryID: number = 0; //进来ticket时的原始subCategoryID
  listOfColumn = [
    {
      title: this.translate.instant('log.time'),
    },
    {
      title: this.translate.instant('log.role'),
    },
    {
      title: this.translate.instant('log.action'),
    },
  ]; // 日志列表显示
  logListOfData: TicketLogsItem[] = []; // 日志数据
  isShowAccept: boolean = false; //接受弹窗显示
  ticketStatusID: number = 0//ticket状态 0 新建  1 提交  2 接受  3 关闭
  ticketStatusEnum:TicketStatusEnum = {
    create: 0,
    submitted: 1,
    inProgress: 2,
    closed: 3,
    reassign: 4,
    cancel: 5
  }//状态对象枚举
  isClosedVisible: boolean = false; //是否关闭ticket弹窗显示
  isClosedTicket: boolean = false; //关闭ticket弹窗显示
  problemCategoryList: CategoryItem[] = [];//问题下拉列表
  problemSubCategoryList: SubCategoryItem[] = [];//子问题下拉列表
  resolutionTypeList: ResolutionTypeList[] = [];//问题下拉列表
  assignedToTeamList: AssignedToTeamItem[] = []; //assined team 列表
  lang = localStorage.getItem('lang') || 'en' //语言
  private langChangeSubscription: any; // Track subscription for cleanup
  createDate = new Date();
  ccEmailList:any[] = [
  ]; //ccEmial 列表
  isClickEmail: boolean = false;//判断是否鼠标点击
  isMousemoveEmail: boolean = false;//判断是否鼠标移入
  timer:any = null; //計時器
  isReassignTicket:boolean = false; //分配弹窗显示
  assignedToTeamName :string = '' ;
  assignedToTeamNameChangeSubCategory:string = '' ;
  assignedToTeamIDParam :number = 0;
  isNotSupportTeam:boolean = false; //其他supportteam打开
  isBackConfirm:boolean = false; 
  isChangeProblemSubCategory:boolean = false;//是否修改了ProblemSubCategory，如果修改就不显示Ressign按钮
  isSaveTicket:boolean = false;//是否保存ticket
  remarkList:any[] = [];
  isHaveSupportTeamOperate:boolean = false;//是否supportTeam操作过了
  rowVersion:string = ""//版本戳 用于防重复
  constructor(private router: Router,private fb: FormBuilder, private ticketService: TicketService,private translate : TranslateService,
    private inquiryService: InquiryService,private route: ActivatedRoute, private message: NzMessageService) {
    // Subscribe to language changes to update lang property reactively
    this.langChangeSubscription = this.translate.onLangChange.subscribe((event: any) => {
      console.log('🌐 [Mobile-Ticket] Language changed to:', event.lang);
      this.lang = event.lang;
      localStorage.setItem('lang', event.lang);
      // Update form values that depend on language
      this.updateFormLanguageValues();
    });
  }

  // Update form values when language changes
  private updateFormLanguageValues(): void {
    if (this.ticketForm) {
      // Update category name
      const categoryID = this.ticketForm.get('categoryID')?.value;
      if (categoryID) {
        const category = this.problemCategoryList.find(cat => cat.id === categoryID);
        if (category) {
          const categoryName = this.lang == 'en' ? category.categoryDescrEng : category.categoryDescrChi;
          this.ticketForm.get('categoryName')?.setValue(categoryName || '');
        }
      }

      // Update subcategory name
      const subCategoryID = this.ticketForm.get('subCategoryID')?.value;
      if (subCategoryID) {
        const subCategory = this.problemSubCategoryList.find(sub => sub.id === subCategoryID);
        if (subCategory) {
          const subCategoryName = this.lang == 'en' ? subCategory.subCategoryDescrEng : subCategory.subCategoryDescrChi;
          this.ticketForm.get('subCategoryName')?.setValue(subCategoryName || '');
        }
      }

      // Update resolution type name
      const resolutionTypeID = this.ticketForm.get('resolutionTypeID')?.value;
      if (resolutionTypeID) {
        const resolutionType = this.resolutionTypeList.find(rt => rt.id === resolutionTypeID);
        if (resolutionType) {
          const resolutionTypeName = this.lang == 'en' ? resolutionType.resolutionTypeDescrEng : resolutionType.resolutionTypeDescrChi;
          this.ticketForm.get('resolutionTypeName')?.setValue(resolutionTypeName || '');
        }
      }
    }
  }

  // ✅ Fix: Initialize isSupport with proper admin and support team checks
  initAdminSupport(): void {
    // Refresh userInfo from localStorage to get latest data
    const storedUser = localStorage.getItem('User');
    if (storedUser) {
      const freshUserInfo = JSON.parse(storedUser);
      this.userInfo = { ...this.userInfo, ...freshUserInfo };
    }

    const userEmail = this.userInfo.email || this.userInfo.userPrincipalName || '';
    const userName = this.userInfo.name || this.userInfo.displayName || '';
    const userRoles = this.userInfo.roles || [];

    // Check if user is admin (can manage all tickets regardless of support team)
    const adminEmails = ['karl.li@gti.com.hk', 'mike.ng@gti.com.hk', 'admin@gti.com.hk', 'admin'];
    this.isAdmin = userRoles.includes('Admin') ||
                   userRoles.includes('admin') ||
                   userRoles.includes('Administrator') ||
                   adminEmails.some(email => userEmail.toLowerCase().includes(email.toLowerCase()));

    // Dev override users
    const isDevOverrideUser = this.DEV_SUPPORT_USERS.some(devUser =>
      userEmail.toLowerCase().includes(devUser.toLowerCase()) ||
      userName.toLowerCase().includes(devUser.toLowerCase())
    );

    // Check supportTeam from userInfo
    const freshUserHasSupportTeam = this.userInfo.supportTeam && this.userInfo.supportTeam.length > 0;
    const localIsSupport = localStorage.getItem('isSupport') === 'true';

    // Priority: 1) Admin user, 2) supportTeam in userInfo, 3) localStorage isSupport flag, 4) Dev override
    if (this.isAdmin) {
      this.isSupport = true;
      console.log('🔍 [Mobile-Ticket] ✅ isSupport = TRUE (user is Admin)');
    } else if (freshUserHasSupportTeam) {
      this.isSupport = true;
      console.log('🔍 [Mobile-Ticket] ✅ isSupport = TRUE (supportTeam found in userInfo)');
    } else if (localIsSupport) {
      this.isSupport = true;
      console.log('🔍 [Mobile-Ticket] ✅ isSupport = TRUE (from localStorage isSupport flag)');
    } else if (isDevOverrideUser) {
      this.isSupport = true;
      console.log('🔍 [Mobile-Ticket] ✅ isSupport = TRUE (DEV OVERRIDE for user:', userEmail, ')');
    } else {
      this.isSupport = false;
      console.log('🔍 [Mobile-Ticket] ❌ isSupport = FALSE (no support access found)');
    }

    console.log('🔍 [Mobile-Ticket] Final isSupport:', this.isSupport, '| isAdmin:', this.isAdmin);
  }
   ngOnInit() {
    // ✅ Fix: Initialize isSupport with proper admin and support team checks
    this.initAdminSupport();
    this.initTicketInfo();

    this.inquiryService.getProblemCategory()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (list) => {
          this.problemCategoryList = list.data;
        },
        error: (err) => {
          console.error('Error fetching problem category list', err);
        },
      });
    this.inquiryService.getResolutionTypeList()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (list) => {
          this.resolutionTypeList = list.data;
        },
        error: (err) => {
          console.error('Error fetching resolution type list', err);
        },
      });
    this.getCCToEmailList();
    this.route.queryParams
      .pipe(takeUntil(this.destroy$))
      .subscribe(params => {
      this.ticketGuid = params['guid'] ;
      this.ticketId = params['id'] ;
      if (this.ticketGuid) {
       this.initInfoByGuid()
      }
    });
    this.route.params
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data: any) => {
          if (data.categoryCode) {
            this.ticketService.getCategoryIDByCode(data.categoryCode, data.subCategoryCode)
              .pipe(takeUntil(this.destroy$))
              .subscribe({
                next: (res) => {
                  this.ticketForm.get('categoryID')?.setValue(res.categoryID);
                  if (res.categoryID > 0) {
                    this.getProblemSubCategory(parseInt(res.categoryID));
                  }
                  if (res.subCategoryID > 0) {
                    this.ticketForm.get('subCategoryID')?.setValue(parseInt(res.subCategoryID));
                  }
                },
                error: (err) => {
                  console.error('Error fetching category ID by code', err);
                },
              });
          }
        }
      });
  }
   async initInfoByGuid(){
    this.isShowLoading = true;
    
    await this.getTicketById();
    
   }

   //获取抄送email列表
   getCCToEmailList(): void {
    this.ticketService.getMailList()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res) => {
          res.data.forEach((mailItem: any) => {
            if (mailItem.mail) {
              this.ccEmailList.push(mailItem.mail);
            }
          });
        },
        error: (err) => {
          console.error('Error fetching mail list', err);
        },
      });
  }
  //获取子问题类型-根据问题id
  getProblemSubCategory(id: number, isChange?: boolean): void {
    this.ticketService.getProblemSubCategory(id)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res) => {
          this.problemSubCategoryList = res.data;
          if (isChange) {
            this.ticketForm.get('subCategoryID')?.setValue('');
          }
        },
      error: (err) => {
        console.error('Error fetching problem sub-category', err);
      },
    });
  }
  //获取ticket详情信息
  getTicketById(): void {
    this.ticketService.getTicketInfo(this.ticketGuid)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res) => {
          this.rowVersion = res?.ticket.rowVersion;
          //判断是否是support 自己创建的单子
          let findTeam = this.userInfo.supportTeam.find((team: any) => {
            return team.teamID == res.ticket?.assignedToTeamID;
          });
          // ✅ Fix: Don't override isSupport if user is admin - admins can always manage tickets
          if (!this.isAdmin && this.userInfo.userPrincipalName == res.ticket?.createdUser && !findTeam) {
            this.isSupport = false;
          }

          if (!findTeam && this.isSupport) {
            this.isNotSupportTeam = true;
          }
          this.ticketId = res.ticket?.id;
        this.ticketStatusID = res.ticket?.ticketStatusID;
        this.isShowLoading = false;
        this.originalSubCategoryID = res.ticket?.subCategory.id;
        this.ticketNo = res.ticket?.ticketNo;
        this.deviceInfo = res.ticket?.clientInfo;
        this.assignedToTeamIDParam = res.ticket?.assignedToTeamID;
        this.ticketForm = this.fb.group({
          id: [res.ticket?.id],
          ticketNo: [res.ticket?.ticketNo],
          ticketStatusID: [res.ticket?.ticketStatusID],
          fullName: [res.user?.displayName],
          email: [res.user?.mail],
          contactNo: [res.ticket?.contactNo == 'null' ? '' : res.ticket?.contactNo || '', this.ticketStatusID == 0 ? [Validators.required] : ''],
          submittedDate: [res.ticket?.submittedDate],
          categoryID: [res.ticket?.subCategory.categoryID, [Validators.required]],
          categoryName: [this.lang == 'en' ? res.ticket?.subCategory?.category?.categoryDescrEng : res.ticket?.subCategory?.category?.categoryDescrChi],
          subCategoryID: [res.ticket?.subCategoryID, [Validators.required]],
          subCategoryName: [this.lang == 'en' ? res.ticket?.subCategory?.subCategoryDescrEng : res.ticket?.subCategory?.subCategoryDescrChi],
          emailCC: [[]],
          detail: [res.ticket?.detail, [Validators.required]],
          severityLevel: [res.ticket?.severityLevel || 3, this.isSupport ? [Validators.required] : ''],
          resolutionTypeID: [res.ticket?.resolutionTypeID, this.isSupport ? [Validators.required] : ''],
          resolutionTypeName: [this.lang == 'en' ? res.ticket?.resolutionType?.resolutionTypeDescrEng : res.ticket?.resolutionType?.resolutionTypeDescrChi],
          actualTimeSpent: [res.ticket?.actualTimeSpent, this.isSupport ? [Validators.required] : ''],
          resolutionComments: [res.ticket?.resolutionComments, this.isSupport ? [Validators.required] : ''],
          acceptedUser: [res.acceptedByName],
          acceptedDate: [res.ticket?.acceptedDate ? new Date(res.ticket?.acceptedDate) : ''],
          firstAcceptedUser: [res.firstAcceptedByName],
          firstAcceptedDate: [res.ticket?.firstAcceptedDate ? new Date(res.ticket?.firstAcceptedDate) : ''],
          closedUser: [res.closedByName],
          closedDate: [new Date(res.ticket?.closedDate)],
          createdDate: [res.ticket?.createdDate],
          createdUser: [res.ticket?.createdUser],
          assignedToTeamID: [res.ticket?.assignedToTeamID],
          assignedToTeamName: [res.ticket?.assignedToTeam?.name],
          firstAssignedToTeamID: [res.ticket?.firstAssignedToTeamID],
          firstAssignedToTeamName: [res.ticket?.firstAssignedToTeam?.name],
        });
        this.getProblemSubCategory(res.ticket?.subCategory.categoryID);
        if (res.ticket?.ticketEmailCCs.length > 0) {
          let emailList: string[] = [];
          this.showEmailList = '';
          res.ticket?.ticketEmailCCs.forEach((value: any) => {
            this.showEmailList = value.email + ';' + this.showEmailList;
            emailList.push(value.email);
          });
          this.ticketForm.get('emailCC')?.setValue(emailList);
        }
        this.originalticketForm = JSON.parse(JSON.stringify(this.ticketForm.value));
        this.getFilesById();
        this.showRemark();
      },
      error: (err) => {
        console.error('Error fetching ticket info', err);
      },
    });
  }
  //获取文件列表
  getFilesById(): void {
    this.ticketService.getAttachmentsByID(this.ticketId)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res) => {
          this.fileList = res.data;
          this.originalFileList = JSON.parse(JSON.stringify(res.data));
          this.fileList.forEach((file) => {
            this.getFileById(file.id);
          });
          this.showFileName();
        },
        error: (err) => {
          console.error('Error fetching attachments', err);
        },
      });
  }
  //显示文件集合名称
  showFileName():void{
    this.fileName = "";
    for (let val of this.fileList) {
      this.fileName = val.originalFileName + ";" + this.fileName;
    }
  }
  //初始化ticket信息
  initTicketInfo() {
    this.ticketForm = this.fb.group({
      id: [0],
      ticketNo: [""],
      ticketStatusID: [0],
      fullName: [this.userInfo.displayName],
      email: [this.userInfo.mail],
      contactNo: ['', this.ticketStatusID == 0 ? [Validators.required] : ''],
      submittedDate: [new Date()],
      categoryID: ['', [Validators.required]],
      categoryName: [''],
      subCategoryID: ['', [Validators.required]],
      subCategoryName: [''],
      emailCC: [[]],
      detail: ['', [Validators.required]],
      severityLevel: [3],
      resolutionTypeID: [null],
      resolutionTypeName: [''],
      actualTimeSpent: [''],
      resolutionComments: [''],
      acceptedUser: [''],
      acceptedDate: [''],
      firstAcceptedUser: [''],
      firstAcceptedDate: [''],
      closedUser: [''],
      closedDate: [''],
      createdDate: [''],
      createdUser: [''],
      assignedToTeamID: [0],
      firstAassignedToTeamID: [0]
    });
    this.remarkForm = this.fb.group({
      remark:['']
    })
  }
  //返回到列表页面（相当于关闭ticket）
  back(isBack?:boolean) {
    if(!isBack && (this.ticketStatusID == 0 ? this.ticketForm.dirty : this.saveFromDirty() || this.isFileChange)){
      this.isBackConfirm = true;
      return;
    }
    this.router.navigate(['/inquiry']);
  }
  //提交或保存ticket
  async saveForm() {
    this.isLoading = true;
    let param:any = {
      "id": this.ticketForm.value.id,
      "detail": this.ticketForm.value.detail,
      "ticketStatusID": this.ticketForm.value.ticketStatusID || null,
      "assignedToTeamID": null,
      "resolutionTypeID": this.ticketForm.value.resolutionTypeID || null,
      "resolutionComments": "",
      "severityLevel": this.ticketForm.value.severityLevel || null,
      "subCategoryID": this.ticketForm.value.subCategoryID,
      "clientInfo": "",
      "contactNo": this.ticketForm.value.contactNo + "",
      "emailCC": this.ticketForm.value.emailCC,
      "attachmentIsModified":false
    }
    if(this.ticketForm.value.id != 0){
      param.rowVersion = this.rowVersion
    }
    this.ticketNo = "";
    //判断是否删除或添加file
    let addFile :any = {}; 
    //是否有新增文件
    addFile =  this.fileList.find((file)=>{
      return !file.id
    })
    if(this.ticketId){
      this.isSaveTicket = true;
      if(this.originalFileList.length != this.fileList.length || this.originalFileList.toString() != this.fileList.toString() || addFile){
        //是否删除或添加字段为true
        param.attachmentIsModified = true;
      }
    }
    if(this.ticketStatusID != 0 && !this.saveFromDirty() && !this.isFileChange){
      this.isLoading = false;
      return;
    }
    try {
      let res: any = await firstValueFrom(
        this.ticketService.saveTicketInfo(param)
      );
      this.isLoading = false
      this.isChangeProblemSubCategory = false;
      this.isSubmitVisible = true;
      this.ticketId = res.id;
      this.ticketGuid = res.guid;
      this.ticketNo = res.ticketNo;
      this.getTicketById();
      //删除文件
      if(this.delFileList.length>0){
        this.delFileList.forEach((id)=>{
          this.ticketService.deleteFilesByID(id).subscribe(() => {
          })
        })
      }
      //如果修改了问题类型就判断
      if (this.ticketStatusID != 0 && this.originalSubCategoryID != this.ticketForm.value.subCategoryID) {
        this.changeProblemCategory(1)
      }
      //判断是否是support 自己创建的单子 并且分配给其他team
      let findTeam = this.userInfo.supportTeam.find((team:any)=>{
        return team.teamID == res.assignedToTeamID
      })
      // ✅ Fix: Don't override isSupport if user is admin - admins can always manage tickets
      if(!this.isAdmin && this.userInfo.userPrincipalName == res.createdUser && !findTeam){
        this.isSupport = false;
      }
      this.originalticketForm = JSON.parse(JSON.stringify(this.ticketForm.value));
      //调用文件导入接口
      const formData = new FormData();
      
      if (this.fileList.length > 0) {
        this.fileList.forEach((file) => {
          if (!file.id) formData.append('files', file);
        })
        if(addFile){
          await firstValueFrom(
            this.ticketService.importAttachment(res.id, formData)
          );
        }  
      }
    }
    catch (error:any) {
      if( error?.error?.code == 409){
        this.isHaveSupportTeamOperate = true;
      }
      this.isLoading = false
    }
  }
  backToTicketOperate(){
    this.isHaveSupportTeamOperate = false;
    this.getTicketById();
  }
  //重置列表信息 用于创建新的ticket
  resetForm(e: MouseEvent): void {
    e.preventDefault();
    this.ticketForm.reset();
  }
  //取消列表-如果有id就取消ticekt，没有id就关闭
  cancelForm(): void {
    if (this.ticketForm.get('ticketNo')?.value) {
      this.isCancelVisible = true;
    } else {
      this.back(true)
    }
  }
  //返回到ticket-用于弹框
  backToTicket() {
    this.isCancelVisible = false;
    this.isReassignTeam = false;
    this.isShowAccept = false;
    this.isClosedVisible = false;
    this.isBackConfirm = false;
    this.isShowChangeSubCategoryReassignLog = false;
    this.isShowAcceptSubCategory = false;
  }
  /*
  *弹框方法-start
  *********************************************************************************************************
  */
  handleOk(): void {
    this.isSubmitVisible = false;
    this.back(true);
  }
  handleBack(): void {
    this.isSubmitVisible = false;
    this.ticketStatusID = (this.ticketStatusID == this.ticketStatusEnum['inProgress'] || this.ticketStatusID == this.ticketStatusEnum['reassign'] ) ? this.ticketStatusID : 1;
    //suppot 回显信息
    const findCategory = this.problemCategoryList.find((item) => {
      return item.id == this.ticketForm.value.categoryID
    })
    this.ticketForm.get('categoryName')?.setValue(this.lang == "en" ? findCategory?.categoryDescrEng : findCategory?.categoryDescrChi)
    const findSubCategory = this.problemSubCategoryList.find((item) => {
      return item.id == this.ticketForm.value.subCategoryID
    })
    this.ticketForm.get('subCategoryName')?.setValue(this.lang == "en" ? findSubCategory?.subCategoryDescrEng : findSubCategory?.subCategoryDescrChi)
    //显示文件
    this.isFileChange = false;
    this.getFilesById();
  }
  handleCancelBack(): void {
    this.isCancelVisible = false;
  }

  closeTicket(): void {
    this.backToTicket();
    this.back(true);
  }
  async handleCancelOk() {
    this.isButtonLoading = true;
    try {
      let param = {
        ticketStatusID: 5,
        ticketStatus: "Canceled",
        supportTeamID: 0,
        rowVersion: this.rowVersion
      }
      await firstValueFrom(
        this.ticketService.updateTicketStatus(this.ticketId, param)
      );
      this.isButtonLoading = false;
      this.isClosed = true;
    } catch (error) {
      this.isButtonLoading = false;
      this.isCancelVisible = false;
      this.isHaveSupportTeamOperate = true;
    }
  }
  openNewTicket(): void {
    this.isClosed = false;
    this.isCancelVisible = false;
    this.ticketStatusID = 0;
    this.initTicketInfo();
  }
  /*
  *弹框方法-end
  *********************************************************************************************************
  */

  /*
  *文件处理方法-start
  *********************************************************************************************************
  */
  //选择文件
  import(e: any): void {
    for (let val of e.target.files) {
      val.originalFileName = val.name;
      val.fileMimeType = val.type;
      this.fileName = val.name + ";" + this.fileName;
      this.isFileChange = true;
      var reader = new FileReader();
      reader.readAsDataURL(val);
      reader.onload = (e:any) => { 
        val.showImage = e.target.result
        this.fileList.push(val);
      }
    }
  }
  //获取文件
  getFileById(id:number){
    this.ticketService.downloadFilesByID(id,true)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data) => {
         var reader = new FileReader();
         reader.readAsDataURL(data);
         reader.onload = (e:any) => {
           const findCategory = this.fileList.find((file)=>{
            return file.id == id;
          })
          findCategory.showImage = e.target.result;
         }

        },
        error: (error) => {
          console.error('Error downloading the file. error: ' + error);
        }
      })
  }
  //下载文件
  downloadFile(id:number,fileName:string): void{
    this.ticketService.downloadFilesByID(id)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
      next: (data) => {
        saveAs(data, fileName);
      },
      error: (error) => {
        console.error('Error downloading the file. error: ' + error);
      }
    })
  }
  //删除文件
  deleteFiles(file?: any): void {
    if (file.id) {
      this.ticketService.deleteFilesByID(file.id)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: () => {
            let fileIndex = this.fileList.findIndex((item) => {
              return file.id == item.id;
            });
            this.fileList.splice(fileIndex, 1);
            this.showFileName();
          },
          error: (err) => {
            console.error('Error deleting file', err);
          },
      });
    } else {
      let fileIndex = this.fileList.findIndex((item) => {
        return file.name == item.name;
      });
      this.fileList.splice(fileIndex, 1);
      this.isFileChange = true;
      this.showFileName();
    }
  }
  /*
  *文件处理方法-end
  *********************************************************************************************************
  */

  //support-接受ticket
  async acceptForm(isClose?: boolean) {
    
    this.isLoading = true;
    try{
      if (!isClose) {
        //如果操作者选择新的SubCategory则提示他一下
        if(this.changeProblemSubCategoryAndAcceptOrClose()){
          return;
        }
        this.ticketForm.get('ticketStatusID')?.setValue(2)
        if(this.saveFromDirty()){
          await this.saveAcceptForm();
        }
        let param = {
          ticketStatusID: 2,
          ticketStatus: "Accepted",
          supportTeamID: 0,
          rowVersion:this.rowVersion
        }
        await firstValueFrom(
          this.ticketService.updateTicketStatus(this.ticketId, param)
        );
        this.isShowAccept = true;
        this.isLoading = false;
        this.getTicketById();
      }else{
        let param = {
          ticketStatusID: 2,
          ticketStatus: "Accepted",
          supportTeamID: 0,
          rowVersion:this.rowVersion
        }
        let res = await firstValueFrom(
          this.ticketService.updateTicketStatus(this.ticketId, param)
        );
        this.rowVersion = res.data?.rowVersion
      }
    }catch (error) {
      this.isHaveSupportTeamOperate = true;
      this.isLoading = false;
    }
  }
  async acceptFormChangeSubCategory(){
    this.isButtonLoading = true
    let param = {
      ticketStatusID: 2,
      ticketStatus: "Accepted",
      supportTeamID: 0,
      rowVersion:this.rowVersion
    }
    this.isLoading = true;
    try{
        this.ticketForm.get('ticketStatusID')?.setValue(2)
        if(this.saveFromDirty()){
          await this.saveAcceptForm();
        }
        this.isButtonLoading = false;
        this.isShowAcceptSubCategory = false;
        await firstValueFrom(
          this.ticketService.updateTicketStatus(this.ticketId, param)
        );
        await this.getTicketById();
        this.isShowAccept = true;
        this.isLoading = false;
    }catch (error) {
      this.isHaveSupportTeamOperate = true;
      this.isLoading = false;
    }
  }
  changeProblemSubCategoryAndAcceptOrClose(){
    if(this.isChangeProblemSubCategory && this.originalticketForm.subCategoryID != this.ticketForm.value.subCategoryID && !this.isShowAcceptSubCategory){
      this.isShowAcceptSubCategory = true;
      return true
    }
    return false
  }
  //support-重新分配ticket
  async reassignTeam() {
    if(this.isChangeProblemSubCategory && this.ticketStatusID != 0 && this.originalticketForm.subCategoryID != this.ticketForm.value.subCategoryID){
      this.isShowChangeSubCategoryReassignLog = true;
      return ;
    }
    this.ticketService.getSupportTeam(this.assignedToTeamIDParam)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res) => {
          this.assignedToTeamList = res.data;
          this.isReassignTeam = true;
        },
        error: (err) => {
          console.error('Error fetching support team', err);
        },
    });
  }
  //分配接口
  async reassign() {
    if (this.assignedToTeamID == 0 && !this.isChangeProblemSubCategory) {
      return;
    }
    let param = {
      ticketStatusID: this.ticketStatusID == this.ticketStatusEnum['inProgress'] || this.ticketStatusID == this.ticketStatusEnum['reassign'] ? 4 : 1,
      ticketStatus: "Assigned",
      supportTeamID:  this.assignedToTeamID || 0,
      rowVersion:""
    }
    this.isButtonLoading = true;
    try{
      await this.saveAcceptForm(param.ticketStatusID);
      param.rowVersion = this.rowVersion;
      if(this.isChangeProblemSubCategory){
        let res = await firstValueFrom(
          this.ticketService.getReassignTeamName(this.ticketForm.value.subCategoryID)
        );
        this.assignedToTeamNameChangeSubCategory= res.name;
        param.supportTeamID = res.id;
      }
      await firstValueFrom(
        this.ticketService.updateTicketStatus(this.ticketId, param)
      );
      this.ticketForm.get('assignedToTeamID')?.setValue(this.assignedToTeamID)
      this.isButtonLoading = false;
      this.isReassignTicket = true
      let find = this.assignedToTeamList.find((team) => {
        return team.id == this.assignedToTeamID
      })
      this.assignedToTeamName = find ? find.name : '';

    }catch (error) {
      this.isReassignTeam = false;
      this.isHaveSupportTeamOperate = true;
      this.isButtonLoading = false;
    }
  }
  async changeSubCategoryReassignOK(){
    await this.reassign();
    this.isShowReassignTicket = true;
  }
  //显示日志
  showLogs(): void {
    this.router.navigate(['/mobile-log'],{queryParams:{id:this.ticketId,ticketNo:this.ticketNo,guid:this.ticketGuid}});
  }
  //显示评论
  showRemark(): void {
    let param = {
      "page": 0,
      "pageSize": 100,
      "keyword": "",
      "ticketId": this.ticketId,
      "isDescrSubmittedDate": true,
      "skipUntil": "",
      "skipIds": [],
    }
    this.ticketService.getTicketRemark(param)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res) => {
          this.remarkList = res.data;
        },
        error: (err) => {
          console.error('Error fetching ticket remark', err);
        },
      });
  }

  //support-接受日志后填写信息保存
  async saveAcceptForm(ticketStatusID?:number) {
    this.isLoading = true;
    let param = {
      "detail": this.ticketForm.value.detail,
      "ticketStatusID": this.ticketForm.value.ticketStatusID,
      "assignedToTeamID": this.ticketForm.value.assignedToTeamID,
      "subCategoryID": this.ticketForm.value.subCategoryID,
      "clientInfo": "",
      "contactNo": this.ticketForm.value.contactNo + "",
      "emailCC": this.ticketForm.value.emailCC,
      "id": this.ticketForm.value.id,
      "resolutionTypeID": this.ticketForm.value.resolutionTypeID,
      "actualTimeSpent": this.ticketForm.value.actualTimeSpent,
      "resolutionComments": this.ticketForm.value.resolutionComments,
      "severityLevel": this.ticketForm.value.severityLevel,
      "rowVersion":this.rowVersion
    }
    try{ 
      if(!this.saveFromDirty()){
          this.isLoading = false;
        return ;
      }
      let res: any = await firstValueFrom(
        this.ticketService.postTicketInfo(param)
      );
      this.rowVersion = res.rowVersion;
      this.assignedToTeamID = res.assignedToTeamID
      //如果修改了问题类型就判断
      // if (this.originalSubCategoryID != this.ticketForm.value.subCategoryID && ticketStatusID) {
      //   this.changeProblemCategory(ticketStatusID || 2)
      // }

      this.originalticketForm = JSON.parse(JSON.stringify(this.ticketForm.value));
      this.isLoading = false;
    }catch (error) {
      this.isHaveSupportTeamOperate = true;
      this.isLoading = false;
    }
  }
  //关闭ticket
  closeTicketForm(): void {
    this.isClosedVisible = true;
  }
  //关闭接口
  async handleClosedOk() {
    this.isButtonLoading = true;
    try{
      if (this.ticketStatusID == this.ticketStatusEnum['submitted'] || this.ticketStatusID == this.ticketStatusEnum['reassign']) {
        await this.saveAcceptForm();
        await this.acceptForm(true);
      } else if (this.ticketStatusID == this.ticketStatusEnum['inProgress'] ) {
        await this.saveAcceptForm();
      }
      let param = {
        ticketStatusID: 3,
        ticketStatus: "Closed",
        supportTeamID: 0,
        rowVersion:this.rowVersion
      }
      await firstValueFrom(
        this.ticketService.updateTicketStatus(this.ticketId, param)
      );
      this.isButtonLoading = false;
      this.isClosedTicket = true;
    }catch (error) {
      this.isHaveSupportTeamOperate = true;
      this.isButtonLoading = false;
    }
  }
  /**
   *  cctoEmail方法处理-start
   *  *********************************************************************************************************
   */
  blurFunction(): void {
    this.isClickEmail = false;
  }
  clickFunction(): void {
    this.isClickEmail = true;
    this.isMousemoveEmail = false;
  }
  mousemoveFunction(): void {
    this.isMousemoveEmail = true;
  }
  mouseleaveFunction(): void {
    this.isClickEmail = false;
    this.isMousemoveEmail = false
  }
  /**
   *  cctoEmail方法处理-end
   *  *********************************************************************************************************
   */

  //显示pdf
  showPdfInfo(uri:string,id:number,pdfName:string):void{
    this.isShowPdf = true;
    this.pdfSrc =  uri;
    this.pdfId = id;
    this.pdfName = pdfName;
  }

  changeProblemCategory(type?:number):void{
      let param = {
        "ticketStatusID": type,
        "ticketStatus": "ChangeCategory",
        "supportTeamID": 0
      }
      this.ticketService.updateTicketStatus(this.ticketId, param)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: () => {},
          error: (err) => {
            console.error('Error updating ticket status', err);
          },
        });
  }
  getStatus(id: number) {
    let status:any = {
      1:'Submitted',
      2:this.isSupport ? 'In Progress (Accepted)' : 'In Progress',
      3:'Closed',
      4:this.isSupport ? 'In Progress (Reassigned)' : 'In Progress',
      5:'Canceled'
    }
    return status[id]
  }
  saveFromDirty(){
    if(!this.isSupport){
      if(this.originalticketForm.contactNo != this.ticketForm.value.contactNo || this.originalticketForm.emailCC.toString() != this.ticketForm.value.emailCC.toString() || this.originalticketForm.detail != this.ticketForm.value.detail){
        return true;
      }
      return false;
    }else{
      if(this.originalticketForm.categoryID != this.ticketForm.value.categoryID || this.originalticketForm.subCategoryID != this.ticketForm.value.subCategoryID || this.originalticketForm.resolutionTypeID != this.ticketForm.value.resolutionTypeID || this.originalticketForm.severityLevel != this.ticketForm.value.severityLevel || this.originalticketForm.resolutionComments != this.ticketForm.value.resolutionComments || this.originalticketForm.actualTimeSpent != this.ticketForm.value.actualTimeSpent){
        return true;
      }
      return false;
    }
  }

  changeProblemSubCategory(){
    this.isChangeProblemSubCategory = true;
  }

  copyLink(){
    let url = window.location.origin+'/#/inquiry?ticketId='+this.ticketGuid;
    const dataContainer = document.createElement('input');
    dataContainer.value = url;
    document.body.appendChild(dataContainer);
    // 选中并复制文本到剪切板
    dataContainer.select();
    document.execCommand('copy');
    // 移除input元素
    document.body.removeChild(dataContainer);
    this.message.success("URL copied")
  }

  addRemark(){
    this.remarkList.push({
      userAD:this.userInfo.displayName,
      createdDate:new Date().toString(),
      remark:`${this.remarkForm.value.remark}`
    })
    let param = {
      ticketId:this.ticketId,
      remark:`${this.remarkForm.value.remark}`
    }
    this.remarkForm.get('remark')?.setValue("");
    this.ticketService.addRemark(param)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: () => {},
        error: (err) => {
          console.error('Error adding remark', err);
        },
      });
  }

  // ✅ Fix: ngOnDestroy to prevent memory leaks (cleanup subscriptions)
  ngOnDestroy(): void {
    // Cleanup language change subscription
    if (this.langChangeSubscription) {
      this.langChangeSubscription.unsubscribe();
      this.langChangeSubscription = null;
      console.log('🌐 [Mobile-Ticket] Language change subscription cleaned up');
    }

    this.destroy$.next();
    this.destroy$.complete();
    // Clear any timers
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
  }

}
